import { Check, Hammer, Handshake, Layers } from 'lucide-react';
import { APPROACH } from '@/data/about';
import { SlashMark } from '../AmdenMark';
import { Reveal } from '../Reveal';

const PRINCIPLE_ICONS = { hammer: Hammer, handshake: Handshake, layers: Layers };

export const OurApproach = () => (
  <section aria-labelledby="approach-heading" data-testid="approach-section" className="bg-mist py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <p className="flex items-center gap-3">
            <span className="font-mono text-xs font-medium tracking-widest text-gold-700">05</span>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold-700">{APPROACH.eyebrow}</span>
          </p>
          <h2 id="approach-heading" className="mt-4 text-3xl font-extrabold tracking-tight text-navy-900 sm:text-4xl">
            {APPROACH.heading}
          </h2>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-slate-600 sm:text-lg">
            {APPROACH.intro}
          </p>

          <ul className="mt-10 space-y-7">
            {APPROACH.principles.map((p) => {
              const Icon = PRINCIPLE_ICONS[p.icon];
              return (
                <li key={p.title} className="flex items-start gap-4" data-testid={`approach-principle-${p.icon}`}>
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-navy-900 text-white">
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </span>
                  <span>
                    <h3 className="text-lg font-extrabold tracking-tight text-navy-900">{p.title}</h3>
                    <p className="mt-1.5 max-w-md text-sm leading-relaxed text-slate-600 sm:text-base">{p.text}</p>
                  </span>
                </li>
              );
            })}
          </ul>
        </Reveal>

        <Reveal delay={0.12}>
          <div
            data-testid="promise-panel"
            className="relative h-full overflow-hidden rounded-2xl bg-navy-900 p-8 sm:p-12"
          >
            <SlashMark
              className="pointer-events-none absolute -bottom-10 -right-10 h-52 w-52 opacity-[0.06]"
              bar="#ffffff"
              dot="#FFB800"
            />
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold-500">
              {APPROACH.promise.eyebrow}
            </p>
            <ul className="mt-8 space-y-5">
              {APPROACH.promise.points.map((point) => (
                <li key={point} className="flex items-start gap-3.5" data-testid={`promise-point-${point.toLowerCase().replace(/[^a-z]+/g, '-')}`}>
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold-600/20">
                    <Check className="h-3.5 w-3.5 text-gold-500" aria-hidden="true" />
                  </span>
                  <span className="text-base font-semibold text-white sm:text-lg">{point}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
